module.exports = __webpack_public_path__ + "static/media/bg.25f5c9f1.jpg";